"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchToProps = exports.mapStateToProps = void 0;
const divisions_1 = require("ducks/divisions");
const react_redux_1 = require("react-redux");
const divisions_2 = require("selectors/divisions");
const members_1 = require("selectors/members");
const index_1 = __importDefault(require("./index"));
const mapStateToProps = (state) => {
    return {
        divisionsLoaded: (0, divisions_2.divisionsLoaded)(state),
        memberDivisionIds: (0, members_1.memberDivisionIds)(state),
    };
};
exports.mapStateToProps = mapStateToProps;
exports.mapDispatchToProps = { loadDivisions: divisions_1.loadDivisions };
exports.default = (0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps)(index_1.default);
